module.exports = "\r\n/* .view-control .view-control-icon{\r\n  display: none;\r\n} */"